module.exports = __webpack_public_path__ + "static/img/8-2.b1c52c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/8-2.jpg
// module id = Ut5r
// module chunks = 0